import { Link } from "@tanstack/react-router";
import { ArrowUp } from "lucide-react";
import { Wordmark } from "@/components/Wordmark";

export function MarketingFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-border bg-card py-10 px-4 sm:px-6">
      <div className="mx-auto flex max-w-6xl flex-col gap-6 text-sm text-muted-foreground">
        <div className="flex flex-col items-start justify-between gap-6 sm:flex-row">
          <div className="flex flex-col gap-2">
            <Wordmark className="text-xl font-extrabold tracking-tight" />
            <span className="text-foreground">
              © {year}{" "}
              <a
                href="https://lastcut.com"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:opacity-70 transition-opacity underline-offset-2 hover:underline"
              >
                Last Cut Apps LLC
              </a>
            </span>
            <span>All rights reserved</span>
          </div>
          <div className="flex flex-col gap-2 sm:items-end">
            <div className="flex flex-wrap gap-x-6 gap-y-2 font-medium text-foreground">
              <Link to="/" hash="features" className="hover:opacity-70 transition-opacity">Features</Link>
              <Link to="/" hash="pricing" className="hover:opacity-70 transition-opacity">Pricing</Link>
              <Link to="/faq" className="hover:opacity-70 transition-opacity">FAQ</Link>
              <Link to="/contact" className="hover:opacity-70 transition-opacity">Contact</Link>
              <Link to="/auth" className="hover:opacity-70 transition-opacity">Sign In</Link>
            </div>
            <div className="flex flex-wrap gap-x-6 gap-y-2">
              <Link to="/privacy" className="hover:text-foreground transition-colors">Privacy</Link>
              <Link to="/terms" className="hover:text-foreground transition-colors">Terms</Link>
            </div>
            <button
              type="button"
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              className="mt-1 flex items-center gap-1.5 text-xs text-muted-foreground hover:text-foreground transition-colors"
            >
              <ArrowUp className="h-3.5 w-3.5" />
              Back to top
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}
